<template>
  <div id="page-user-view">
    <div class="vx-col flex-1" id="account-info-col-1">
      <form :v-model="data">
      <shipblu-card class="mb-base p-5"  :cardLoading="dataLoading">
        <p class="h4 mb-2">{{$t('Merchant Cash Processing Fees')}}</p>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Cash processing fees')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="cash processing fees" v-model="data.cash_processing_fees" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('cash processing fees')">{{ errors.first('cash processing fees') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Cash processing fees max')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="cash processing fees max"  v-model="data.cash_processing_fees_max" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('cash processing fees max')">{{ errors.first('cash processing fees max') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Cash processing percentage')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="cash processing percentage"  v-model="data.cash_processing_percentage" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('cash processing percentage')">{{ errors.first('cash processing percentage') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Cash processing threshold')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="cash processing threshold"  v-model="data.cash_processing_threshold" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('cash processing threshold')">{{ errors.first('cash processing threshold') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('WhatsApp Fees')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="whatsapp fees"  v-model="data.whatsapp_fees" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('whatsapp fees')">{{ errors.first('whatsapp fees') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Open Package Fees')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable" name="open package fees" v-model="data.open_package_fees" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('open package fees')">{{ errors.first('open package fees') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Refunds Credit Limit')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'required|decimal'" :disabled="!editable || $store.state.AppActiveUser.userRole !== 'admin'" name="refunds credit limit"  v-model="data.refunds_credit_limit" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('refunds credit limit')">{{ errors.first('refunds credit limit') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center h-[44px]">
            <label class="font-semibold">{{$t('Refunds Enabled')}}</label>
          </div>
          <div class="vx-col w-2/3 flex items-center h-[44px]">
            <vs-switch :disabled="!editable || ($store.state.AppActiveUser.userRole !== 'admin' && $store.state.AppActiveUser.userRole !== 'commercial-admin' && editable)" name="refunds enabled" v-model="data.refunds_enabled"/>
            <span class="text-danger text-sm" v-show="errors.has('refunds enabled')">{{ errors.first('refunds enabled') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center h-[44px]">
            <label class="font-semibold">{{$t('Automated Instant payout')}}</label>
          </div>
          <div class="vx-col w-2/3 flex items-center h-[44px]">
            <vs-switch :disabled="!editable || ($store.state.AppActiveUser.userRole !== 'commercial-admin' && editable)" name="Automated Instant payout" v-model="automatedInstantPayout"/>
            <span class="text-danger text-sm" v-show="errors.has('Automated Instant payout')">{{ errors.first('Automated Instant payout') }}</span>
          </div>
          <div class="vx-card__header vx-col w-full pt-6">
            <div class="vx-card__title">
              <p class="h4 mb-2">{{$t('Merchant Minimum Pickup Orders Fees')}}</p>
            </div>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Minimum Pickup orders threshold')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'numeric'" :disabled="!editable || ($store.state.AppActiveUser.userRole !== 'admin' && $store.state.AppActiveUser.userRole !== 'commercial-admin' && editable)" name="Minimum Pickup orders threshold"  v-model="data.minimum_order_per_pickup" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('Minimum Pickup orders threshold')">{{ errors.first('Minimum Pickup orders threshold') }}</span>
          </div>
          <div class="vx-col w-1/3 flex items-center">
            <label class="font-semibold">{{$t('Minimum Pickup fees')}}</label>
          </div>
          <div class="vx-col w-2/3">
            <vs-input v-validate="'decimal'" :disabled="!editable || ($store.state.AppActiveUser.userRole !== 'admin' && $store.state.AppActiveUser.userRole !== 'commercial-admin' && editable)" name="Minimum Pickup fees"  v-model="data.pickup_fees" class="mt-2 w-full"/>
            <span class="text-danger text-sm" v-show="errors.has('Minimum Pickup fees')">{{ errors.first('Minimum Pickup fees') }}</span>
          </div>
        </div>
        <div hidden v-if="['admin', 'commercial-admin'].includes($store.state.AppActiveUser.userRole) && data.buy_and_try_subscriptions && data.buy_and_try_subscriptions.length > 0">
          <div class="vx-card__title">
            <p class="h4 mb-2">{{$t('Merchant Try And Buy Fees')}}</p>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-1/3 flex items-center">
              <label class="font-semibold">{{$t('Merchant Subscription')}}</label>
            </div>
            <div class="vx-col w-2/3">
              <vs-alert color="primary" style="height: fit-content;" icon="info">
                <span class="font-semibold">{{buyAndTrySubscriptions[data.buy_and_try_subscriptions[0].billing_mode]}}</span>
              </vs-alert>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-1/3 flex items-center">
              <label class="font-semibold">{{$t('Try & Buy Fees')}}</label>
            </div>
            <div class="vx-col w-2/3">
              <vs-input v-validate="'required|decimal'" :disabled="!editable" name="try and buy fees" v-model="data.buy_and_try_fees" class="mt-2 w-full"/>
              <span class="text-danger text-sm" v-show="errors.has('try and buy fees')">{{ errors.first('try and buy fees') }}</span>
            </div>
          </div>
          <div v-if="data.buy_and_try_subscriptions[0].billing_mode !== 'upfront'" class="vx-row mb-2">
            <div class="vx-col w-1/3 flex items-center">
              <label class="font-semibold">{{$t('Return COD Charges')}}</label>
            </div>
            <div class="vx-col w-2/3">
              <vs-input v-validate="'required|decimal'" :disabled="!editable" name="try and buy fees" v-model="data.on_return_cod_charges" class="mt-2 w-full"/>
              <span class="text-danger text-sm" v-show="errors.has('try and buy fees')">{{ errors.first('try and buy fees') }}</span>
            </div>
          </div>
        </div>
        <div v-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'commercial-admin'" class="flex flex-wrap items-center justify-end mt-6">
          <vs-button class="ml-auto mt-2" v-if="!editable" @click="editPricing('editable')">{{$t('Edit')}}</vs-button>
          <vs-button class="ml-auto mt-2" v-if="editable" @click="updateMerchant()">{{$t('Save')}}</vs-button>
          <vs-button class="ml-4 mt-2" v-if="editable" @click="cancelEdit()" type="border" color="warning">{{$t('Cancel')}}</vs-button>
        </div>
      </shipblu-card>
      </form>
    </div>
  </div>
</template>

<script>
import {sendRequest} from '../../../http/axios/requestHelper'
import i18nData from '../../../i18n/i18nData.js'
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'
import axios from 'axios'

export default {
  props: ['data'],
  data () {
    return {
      editable: false,
      subscriptionEditable: false,
      dataLoading: false,
      oldPickupOrder: 0,
      oldPickupFees: 0,
      buyAndTrySubscriptions: {
        'on_return_customer_fixed_fees': 'Receiver pays Try & Buy Return Shipping',
        'on_return_merchant': 'Sender pays Try & Buy Return Shipping',
        'upfront': 'Legacy Mode'
      },
      automatedInstantPayout: false
    }
  },
  watch: {
    'data.instant_payout_subscription': {
      immediate: true,
      handler (value) {
        this.automatedInstantPayout = value?.deleted === null
      }
    }
  },
  methods: {
    editPricing (flag) {
      this[flag] = true
      this.oldPickupOrder = this.data.minimum_order_per_pickup
      this.oldPickupFees = this.data.pickup_fees
    },
    cancelEdit () {
      this.editable = false
      this.subscriptionEditable = false
      this.$emit('loadMerchant')
    },
    updateMerchant () {
      this.dataLoading = true
      this.$validator.validateAll().then(result => {
        if (result) {
          const wasSubscribed = this.data.instant_payout_subscription?.deleted === null
          if (this.automatedInstantPayout !== wasSubscribed) {
            this.toggleAutomatedInstantPayout()
          }
          const cashProcessing = {
            cash_processing_fees: this.data.cash_processing_fees,
            cash_processing_fees_max: this.data.cash_processing_fees_max,
            cash_processing_percentage: this.data.cash_processing_percentage,
            cash_processing_threshold: this.data.cash_processing_threshold,
            pricing_lookup: this.data.pricing_lookup_delivery.google_sheet_url,
            refunds_enabled: this.data.refunds_enabled,
            refunds_credit_limit: this.data.refunds_credit_limit,
            whatsapp_fees: this.data.whatsapp_fees,
            open_package_fees: this.data.open_package_fees,
            buy_and_try_fees: this.data.buy_and_try_fees,
            minimum_order_per_pickup:this.data.minimum_order_per_pickup,
            pickup_fees: this.data.pickup_fees
          }
          if ((Number(this.oldPickupOrder) !== Number(this.data.minimum_order_per_pickup)
            || Number(this.oldPickupFees) !== Number(this.data.pickup_fees))
            && this.$store.state.AppActiveUser.userRole === 'commercial-admin') {
            cashProcessing.pricing_update_date = new Date()
          }
          if (this.data.buy_and_try_subscriptions.length > 0) {
            cashProcessing.buy_and_try_subscriptions = [
              {
                billing_mode: this.data.buy_and_try_subscriptions[0].billing_mode,
                fees: this.data.buy_and_try_fees,
                on_return_cod_charges: this.data.on_return_cod_charges
              }
            ]
          }
          sendRequest(true, false, this, `api/v1/merchants/${this.$route.params.merchantID}/`, 'patch', cashProcessing, true,
            () => {
              this.dataLoading = false
              this.editable = false
              this.subscriptionEditable = false
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Merchant'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
            }
          )
        } else {
          this.dataLoading = false
        }
      })
    },
    toggleAutomatedInstantPayout () {
      if (this.automatedInstantPayout) {
        sendRequest(true, false, this, 'api/v1/instant/subscription/', 'post', {merchant_id: this.$route.params.merchantID}, true,
          () => {
            this.$emit('loadMerchant')
          },
          (error) => {
            this.$vs.notify({
              color: 'danger',
              title: i18nData[this.$i18n.locale]['Error'],
              text: error.response?.data?.message || i18nData[this.$i18n.locale]['Something went wrong!'],
              position: 'top-center'
            })
          }
        )
      } else {
        axios.delete(`${process.env.VUE_APP_API_URL}/api/v1/instant/subscription/`, {
          data: { merchant_id: this.$route.params.merchantID },
          headers: {
            'Accept-Language': this.$i18n.locale,
            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
          }
        }).then(() => {
          this.$emit('loadMerchant')
        }).catch((error) => {
          this.$vs.notify({
            color: 'danger',
            title: i18nData[this.$i18n.locale]['Error'],
            text: error.response?.data?.message || i18nData[this.$i18n.locale]['Something went wrong!'],
            position: 'top-center'
          })
        })
      }
    }
  },
  components: {
    ShipbluCard
  }
}
</script>